export function changeObjectToArray(object) {
    let ids = [];
    object.forEach((obj) => {
      const pushed = Number.isInteger(obj) ? obj : obj.id;
      ids.push(pushed);
    });
    return ids;
}

